import { useMemo } from "react";
import { useTranslate } from "ra-core";

const CAMPAIGN_STATUSES = ["draft", "active", "completed"] as const;

export const useCampaignStatusChoices = () => {
  const translate = useTranslate();
  return useMemo(
    () =>
      CAMPAIGN_STATUSES.map((id) => ({
        id,
        name: translate(`resources.campaigns.status.${id}`, {
          _: id.charAt(0).toUpperCase() + id.slice(1),
        }),
      })),
    [translate],
  );
};

export const useCampaignTaskStatusLabel = (status: string) => {
  const translate = useTranslate();
  return translate(`resources.campaigns.status.${status}`, {
    _: status.charAt(0).toUpperCase() + status.slice(1),
  });
};
